import { AddIcon } from 'foundations-assets';
import { IconContainer } from './IconContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconAdd = props => /*#__PURE__*/_jsx(IconContainer, Object.assign({}, props, {
  children: /*#__PURE__*/_jsx(AddIcon, {})
}));